export const colors = {
  lightPurple: '#F5F0FF',
  primary: '#7B39FF',
  success: '#00B282',
  error: '#E13065',
  warning: '#FDAC42',
  danger: '#E13065',
  darkWarning: '#E57A00',
  info: '#00A3FF',
  secondary: '#158CFD',
  purple: '#7B39FF',
  purple1: '#C1B7F0',
  purple2: '#9A89E6',
  purple3: '#7B39FF',
  purple4: '#5946B5',
  purple5: '#392C73',
  purple6: '#D8D0EE',
  purple7: '#8F57FF',
  grey100: '#FCFCFD',
  grey200: '#F4F4F6',
  grey300: '#E8E8ED',
  grey400: '#D4D4DD',
  grey500: '#B8B8C7',
  grey600: '#9595AB',
  grey700: '#717190',
  grey800: '#55556D',
  grey900: '#3A3A49',
  grey1000: '#1E1E26',
  darkPurple: '#18003D',
};
